export const texts = [
  // Properties
  {
    id: 1,
    type: "MultiLineText",
    group: "property",
    x: 480,
    y: 160,
    text: ["Dusit Thani", "Laguna Phuket"],
    style: { fontSize: 11 },
    options: {
      excludes: ["project-map/hotel", "project-map/restaurant"],
    },
  },
  {
    id: 2,
    type: "MultiLineText",
    group: "property",
    x: 332,
    y: 321,
    text: ["Cassia", "Residences", "Phuket"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 3,
    type: "MultiLineText",
    group: "property",
    x: 212,
    y: 441,
    text: ["Dhawa", "Phuket"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 4,
    type: "MultiLineText",
    group: "property",
    x: 547,
    y: 535,
    text: ["Laguna Park", "Phuket"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 5,
    type: "MultiLineText",
    group: "property",
    x: 485,
    y: 456,
    text: ["Laguna Phuket", "Skypark"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 6,
    type: "MultiLineText",
    group: "property",
    x: 1400,
    y: 830,
    text: ["Laguna Park", "Phuket 2"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 7,
    type: "MultiLineText",
    group: "property",
    x: 570,
    y: 300,
    text: ["Angsana", "Oceanview", "Residences"],
    style: { fill: "white" },
    options: {
      excludes: ["masterplan", "project-map/mobile"],
    },
  },
  {
    id: 8,
    type: "MultiLineText",
    group: "property",
    x: 950,
    y: 340,
    style: { fontSize: 11 },
    text: ["Banyan Tree", "3 Bedroom", "Pool Villas"],
  },
  {
    id: 9,
    type: "MultiLineText",
    group: "property",
    x: 1107,
    y: 185,
    text: ["Banyan Tree", "Grand Residences"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 10,
    type: "MultiLineText",
    group: "property",
    x: 1150,
    y: 340,
    text: ["Banyan Tree", "Residences"],
    options: {
      excludes: ["masterplan"],
    },
  },
  {
    id: 11,
    type: "MultiLineText",
    group: "property",
    x: 1020,
    y: 610,
    text: ["Laguna Village", "Residences"],
    options: {
      excludes: ["masterplan", "project-map/project/laguna-village-residences"],
    },
  },
  {
    id: 12,
    type: "MultiLineText",
    group: "property",
    x: 1330,
    y: 670,
    text: ["The Lofts", "at Laguna Village"],
    options: {
      excludes: ["masterplan"],
    },
  },

  // Hotels
  {
    id: 13,
    type: "MultiLineText",
    group: "hotel",
    x: 230,
    y: 130,
    text: ["SAii", "Laguna Phuket"],
    options: {
      excludes: ["project-map/hotel", "project-map/restaurant"],
    },
  },
  {
    id: 14,
    type: "MultiLineText",
    group: "hotel",
    x: 475,
    y: 155,
    text: ["", ""],
  },
  {
    id: 15,
    type: "MultiLineText",
    group: "hotel",
    x: 580,
    y: 215,
    text: ["Angsana", "Laguna Phuket"],
    style: { fontSize: 11, fill: "white" },
    options: {
      excludes: ["project-map/hotel"],
    },
  },
  {
    id: 16,
    type: "MultiLineText",
    group: "hotel",
    x: 730,
    y: 250,
    text: ["Banyan Tree", "Spa Sanctuary"],
    style: { fill: "white" },
    options: {
      // excludes: ['project-map/hotel',]
    },
  },
  {
    id: 17,
    type: "MultiLineText",
    group: "hotel",
    x: 900,
    y: 237,
    text: ["Banyan Tree", "Phuket"],
    style: { fill: "white", fontSize: 10 },
    options: {
      excludes: ["project-map/hotel"],
    },
  },
  {
    id: 18,
    type: "MultiLineText",
    group: "hotel",
    x: 374,
    y: 275,
    text: ["Cassia Phuket"],
    style: { fill: "white" },
    options: {
      excludes: ["project-map/hotel", "project-map/restaurant", "masterplan"],
    },
  },
  // {
  //   type: "MultiLineText",
  //   group: "hotel",
  //   x: 360,
  //   y: 230,
  //   text: ["Dusit Laguna Resort", "Villas Phuket"],
  //   style: { fill: "white" },
  //   options: {
  //     excludes: [],
  //     // excludes: ['project-map/hotel', 'project-map/restaurant', 'masterplan'],
  //   },
  // },
  // {
  //   type: "MultiLineText",
  //   group: "hotel",
  //   x: 730,
  //   y: 155,
  //   text: ["Angsana Beachfront", "Residences"],
  //   style: { fontSize: 12 },
  //   options: {
  //     // excludes: ['project-map/hotel',]
  //   }
  // },
  {
    id: 19,
    type: "MultiLineText",
    group: "hotel",
    x: 340,
    y: 540,
    text: ["Laguna", "Main Entrance"],
  },
  {
    id: 20,
    type: "MultiLineText",
    group: "hotel",
    x: 489,
    y: 390,
    text: ["Laguna Holidays Club", "Phuket Resort"],
    style: { fontSize: 8 },
    options: {
      excludes: ["project-map/hotel"],
    },
  },
  {
    id: 21,
    type: "MultiLineText",
    group: "hotel",
    x: 740,
    y: 400,
    style: { fontSize: 10 },
    text: ["Allamanda", "Laguna Phuket"],
  },
  {
    id: 22,
    type: "MultiLineText",
    group: "hotel",
    x: 1310,
    y: 960,
    text: ["Laguna Park 2", "Main Entrance"],
  },
  {
    id: 23,
    type: "MultiLineText",
    group: "hotel",
    x: 1330,
    y: 570,
    text: ["Angsana", "Villas Resort", "Phuket "],
    options: {
      excludes: ["project-map/hotel", "project-map/restaurant"],
    },
  },

  // Facilities
  {
    id: 24,
    type: "MultiLineText",
    group: "facility",
    x: 620,
    y: 180,
    style: { fontSize: 11 },
    text: ["XANA", "Beach Club"],
  },
  {
    id: 25,
    type: "MultiLineText",
    group: "facility",
    x: 870,
    y: 330,
    style: { fontSize: 11 },
    text: ["Laguna Golf", "Phuket"],
  },
  {
    id: 26,
    type: "MultiLineText",
    group: "facility",
    x: 445,
    y: 270,
    text: ["Latitude", "Marquee"],
    style: { fontSize: 8 },
  },
  {
    id: 27,
    type: "MultiLineText",
    group: "facility",
    x: 555,
    y: 252,
    text: ["Canal Village", "Shopping"],
    style: { fontSize: 8, fill: "white" },
  },
  {
    id: 28,
    type: "MultiLineText",
    group: "facility",
    x: 469,
    y: 318,
    text: ["The Laguna", "Lifestyle Hub"],
    style: { fontSize: 8 },
  },
  {
    id: 29,
    type: "MultiLineText",
    group: "facility",
    x: 510,
    y: 348,
    text: ["Angsana", "Wedding", "Chapel"],
    style: { fontSize: 9, fill: "white" },
  },
  {
    id: 30,
    type: "MultiLineText",
    group: "facility",
    x: 770,
    y: 55,
    text: ["Bang Tao Beach"],
    style: { fontSize: 22, fill: "white" },
  },
  // Arrow Text
  {
    id: 31,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 785,
    textAnchor: "left",
    text: ["Cherngtalay"],
  },
  {
    id: 32,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 855,
    textAnchor: "left",
    text: ["(Half Hour Drive)", "Phuket Town"],
  },
  {
    id: 33,
    type: "MultiLineText",
    group: "map",
    x: 1430,
    y: 165,
    textAnchor: "end",
    text: ["Nai Thon Beach"],
  },
  {
    id: 34,
    type: "MultiLineText",
    group: "map",
    x: 1545,
    y: 970,
    textAnchor: "end",
    text: ["(20-Minute)", "Phuket International Airport"],
  },
  {
    id: 35,
    type: "MultiLineText",
    group: "map",
    x: 1160,
    y: 825,
    textAnchor: "end",
    text: ["Ban Don"],
  },
  {
    id: 36,
    type: "MultiLineText",
    x: 670,
    y: 330,
    text: ["Angsana", "Convention", "and Exhibition", "Space"],
    textAnchor: "middle",
    style: { fontSize: 8, fill: "black" },
  },
  {
    id: 37,
    type: "MultiLineText",
    x: 230,
    y: 595,
    textAnchor: "end",
    text: ["Villa Market"],
  },
  {
    id: 38,
    type: "MultiLineText",
    x: 170,
    y: 630,
    text: ["Boat", "Avenue"],
  },
  {
    id: 39,
    type: "MultiLineText",
    x: 125,
    y: 650,
    textAnchor: "end",
    text: ["Porto de Phuket"],
  },
];

export const CHtexts = [
  // Properties
  {
    id: 1,
    text: ["", ""],
  },
  {
    id: 2,
    text: ["", "", ""],
  },
  {
    id: 3,
    text: ["", ""],
  },
  {
    id: 4,
    text: ["", ""],
  },
  {
    id: 5,
    text: ["", "", ""],
  },
  {
    id: 6,
    style: { fontSize: 10 },
    text: ["普吉岛悦榕轩", "三卧室泳池别墅", ""],
  },
  {
    text: ["", ""],
  },
  {
    id: 7,
    text: ["", ""],
  },
  {
    id: 8,
    text: ["", ""],
  },
  {
    id: 9,
    text: ["", ""],
  },
  {
    id: 10,
    text: ["", ""],
  },
  {
    id: 10,
    text: ["", ""],
  },

  // Hotels
  {
    id: 11,
    text: ["SAii", "Laguna Phuket", ""],
    y: 125,
  },
  {
    id: 12,
    text: ["普吉岛乐古浪都", "喜天阙酒店"],
    y: 153,
  },
  {
    id: 13,
    text: ["普吉岛乐古浪", "悦椿酒店"],
    y: 225,
    style: { fontSize: 11, fill: "white" },
  },
  {
    id: 14,
    style: { fontSize: 10, fill: "white" },
    text: ["悦榕庄心静轩"],
  },
  {
    id: 15,
    y: 242,
    text: ["普吉岛悦榕"],
  },
  // Spa
  {
    id: 16,
    text: [""],
    bubble: {
      text: ["普吉岛乐古浪都", "喜天阙酒店悦椿Spa"],
    },
  },
  {
    id: 17,
    text: ["Laguna", "主入口"],
    bubble: {
      text: ["悦椿SPA", "LAGUNA PHUKET"],
    },
  },
  {
    id: 18,
    text: ["普吉岛乐古浪", "假日俱乐部酒店"],
    bubble: {
      text: ["悦榕Spa"],
    },
  },
  {
    id: 19,
    text: ["普吉岛乐古浪", "阿拉曼达饭店"],
  },
  {
    id: 20,
    text: ["乐古浪熙园 2", "主入口"],
  },
  {
    id: 21,
    text: ["悦椿别墅度假村", "", ""],
  },
  // Facilities
  {
    id: 22,
    x: 620,
    y: 170,
    style: { fontSize: 11, fontColor: "#9e9e9e" },
    text: ["XANA", "海滩俱乐部"],
  },
  {
    id: 23,
    text: ["普吉岛乐古浪", "高尔夫俱乐部"],
  },
  {
    id: 24,
    text: ["Latitude", "华盖"],
  },
  {
    id: 25,
    text: ["运河村购物中心", ""],
    x: 557,
    y: 258,
    style: { fontSize: 7, fill: "white" },
  },
  {
    id: 26,
    text: ["", ""],
  },
  {
    id: 27,
    text: ["悦椿婚", "礼教堂"],
  },
  {
    id: 28,
    text: ["邦涛海滩"],
    x: 730,
    y: 55,
  },
  // Arrow Text
  {
    id: 29,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 785,
    textAnchor: "left",
    text: ["呈塔累"],
  },
  {
    id: 30,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 855,
    textAnchor: "left",
    text: ["(30分钟车程)", "普吉镇"],
  },
  {
    id: 31,
    type: "MultiLineText",
    group: "map",
    x: 1425,
    y: 165,
    textAnchor: "end",
    text: ["直通奈通海滩"],
  },
  {
    id: 32,
    type: "MultiLineText",
    group: "map",
    x: 1540,
    y: 970,
    textAnchor: "end",
    text: ["(20分钟车程)", "普吉岛国际机场"],
  },
  {
    id: 33,
    type: "MultiLineText",
    group: "map",
    x: 1145,
    y: 825,
    textAnchor: "end",
    text: ["班顿"],
  },
  {
    id: 34,
    type: "MultiLineText",
    x: 670,
    y: 330,
    text: ["Angsana", "Convention", "and Exhibition", "Space"],
    textAnchor: "middle",
    style: { fontSize: 8, fill: "black" },
  },
  {
    id: 35,
    type: "MultiLineText",
    x: 230,
    y: 595,
    textAnchor: "end",
    // text: ["Вилла Маркет"],
  },
  {
    id: 36,
    type: "MultiLineText",
    x: 170,
    y: 630,
    // text: ["Боат", "Авеню"],
  },
  {
    id: 37,
    type: "MultiLineText",
    x: 125,
    y: 650,
    textAnchor: "end",
    // text: ["Порто де Пхукет"],
  },
];

export const RUtexts = [
  // Properties
  {
    id: 1,
    type: "MultiLineText",
    group: "property",
    x: 370,
    y: 220,
    text: [""],
    style: { fill: "white" },
  },
  {
    id: 2,
    type: "MultiLineText",
    group: "property",
    x: 332,
    y: 321,
    text: [""],
  },
  {
    id: 3,
    type: "MultiLineText",
    group: "property",
    x: 212,
    y: 441,
    text: ["", ""],
  },
  {
    id: 4,
    type: "MultiLineText",
    group: "property",
    x: 467,
    y: 456,
    text: ["", ""],
  },
  {
    id: 5,
    type: "MultiLineText",
    group: "property",
    x: 570,
    y: 300,
    text: ["", "", ""],
    style: { fill: "white" },
  },
  {
    id: 6,
    type: "MultiLineText",
    group: "property",
    x: 950,
    y: 340,
    style: { fontSize: 10 },
    text: ["Виллы Banyan Tree", "с бассейном и", "3-мя спальнями"],
  },
  {
    id: 7,
    type: "MultiLineText",
    group: "property",
    x: 1107,
    y: 185,
    text: [""],
  },
  {
    id: 8,
    type: "MultiLineText",
    group: "property",
    x: 1150,
    y: 340,
    text: [""],
  },
  {
    id: 9,
    type: "MultiLineText",
    group: "property",
    x: 1020,
    y: 610,
    text: [""],
  },
  {
    id: 10,
    type: "MultiLineText",
    group: "property",
    x: 1330,
    y: 670,
    text: [""],
  },
  {
    id: 11,
    type: "MultiLineText",
    group: "property",
    x: 1400,
    y: 840,
    text: [""],
  },
  {
    id: 11,
    type: "MultiLineText",
    group: "property",
    x: 1400,
    y: 840,
    text: [""],
  },

  // Hotels
  {
    id: 12,
    type: "MultiLineText",
    group: "hotel",
    x: 230,
    y: 130,
    text: ["Отель SAii", "Laguna Phuket"],
  },
  {
    id: 13,
    type: "MultiLineText",
    group: "hotel",
    x: 470,
    y: 160,
    text: ["Отель Dusit Thani", "Laguna Phuket"],
  },
  {
    id: 14,
    type: "MultiLineText",
    group: "hotel",
    x: 580,
    y: 215,
    style: { fill: "white", fontSize: 10 },
    text: ["Отель Angsana", "Laguna Phuket"],
  },
  {
    id: 15,
    type: "MultiLineText",
    group: "hotel",
    x: 730,
    y: 250,
    text: ["Banyan Tree", "Spa Sanctuary"],
    style: { fill: "white" },
  },
  {
    id: 16,
    type: "MultiLineText",
    group: "hotel",
    x: 900,
    y: 235,
    text: ["Отель", "Banyan Tree", "Phuket"],
    style: { fill: "white", fontSize: 7 },
  },
  {
    id: 17,
    type: "MultiLineText",
    group: "hotel",
    x: 374,
    y: 275,
    text: [""],
    style: { fill: "white" },
  },
  {
    id: 18,
    type: "MultiLineText",
    group: "hotel",
    x: 335,
    y: 540,
    text: ["Laguna", "Главный въезд"],
  },
  {
    id: 19,
    type: "MultiLineText",
    group: "hotel",
    x: 495,
    y: 395,
    text: ["Отель", "Laguna Holidays Club", "Phuket Resort"],
    style: { fontSize: 7 },
  },
  {
    id: 20,
    type: "MultiLineText",
    group: "hotel",
    x: 740,
    y: 400,
    text: ["Отель", "Allamanda", "Laguna Phuket"],
  },
  {
    id: 21,
    type: "MultiLineText",
    group: "hotel",
    x: 1310,
    y: 960,
    text: ["Laguna Park 2", "Главный въезд"],
  },
  {
    id: 22,
    type: "MultiLineText",
    group: "hotel",
    x: 1350,
    y: 570,
    text: ["Отель Angsana Villas", "Resort Phuket"],
  },

  // Facilities
  {
    id: 23,
    type: "MultiLineText",
    group: "facility",
    x: 620,
    y: 170,
    style: { fontSize: 11, fontColor: "#9e9e9e" },
    text: ["XANA", "Beach Club"],
  },
  {
    id: 24,
    type: "MultiLineText",
    group: "facility",
    x: 850,
    y: 330,
    style: { fontSize: 10 },
    text: ["Лагуна Гольф Пхукет,", "Таиланд"],
  },
  {
    id: 25,
    type: "MultiLineText",
    group: "facility",
    x: 445,
    y: 275,
    text: ["Место проведения", "мероприятий", "Lattitude Marque"],
    style: { fontSize: 7 },
  },
  {
    id: 26,
    type: "MultiLineText",
    group: "facility",
    x: 555,
    y: 252,
    style: { fontSize: 7, fill: "white" },
    text: ["Шопинг-центр", "Canal Village"],
  },
  {
    id: 27,
    type: "MultiLineText",
    group: "facility",
    x: 469,
    y: 318,
    text: ["The Laguna", "Lifestyle Hub"],
    style: { fontSize: 9 },
  },
  {
    id: 28,
    type: "MultiLineText",
    group: "facility",
    x: 505,
    y: 350,
    text: ["Свадебная", "часовня", "Angsana"],
    style: { fontSize: 9, fill: "white" },
  },
  {
    id: 29,
    type: "MultiLineText",
    group: "facility",
    x: 770,
    y: 55,
    text: ["Пляж Банг Тао (Bang Tao Beach)"],
    style: { fontSize: 22, fill: "white" },
  },
  // Arrow Text
  {
    id: 30,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 785,
    textAnchor: "left",
    text: ["РАЙОН  Cherngtalay"],
    style: { fontSize: 12 },
  },
  {
    id: 31,
    type: "MultiLineText",
    group: "map",
    x: 85,
    y: 855,
    textAnchor: "left",
    text: ["ИСТОРИЧЕСКИЙ  ЦЕНТР", "Phuket  Town  (в  получасе  езды)"],
  },
  {
    id: 32,
    type: "MultiLineText",
    group: "map",
    x: 1425,
    y: 160,
    textAnchor: "end",
    text: ["ПЛЯЖ  НАЙТОН", "(Nai  Thon  Beach)"],
  },
  {
    id: 33,
    type: "MultiLineText",
    group: "map",
    x: 1540,
    y: 960,
    textAnchor: "end",
    text: ["МЕЖДУНАРОДНЫЙ", "АЭРОПОРТ  ПХУКЕТА", "(20  МИНУТ  ЕЗДЫ"],
  },
  {
    id: 34,
    type: "MultiLineText",
    group: "map",
    x: 1160,
    y: 825,
    textAnchor: "end",
    text: ["ХРАМ BAN DON"],
  },
  {
    id: 35,
    type: "MultiLineText",
    x: 670,
    y: 330,
    text: ["Angsana", "Convention", "and Exhibition", "Space"],
    textAnchor: "middle",
    style: { fontSize: 8, fill: "black" },
  },
  {
    id: 36,
    type: "MultiLineText",
    x: 230,
    y: 595,
    textAnchor: "end",
    text: ["Вилла Маркет"],
  },
  {
    id: 37,
    type: "MultiLineText",
    x: 170,
    y: 630,
    text: ["Боат", "Авеню"],
  },
  {
    id: 38,
    type: "MultiLineText",
    x: 125,
    y: 650,
    textAnchor: "end",
    text: ["Порто де Пхукет"],
  },
];



// WEBPACK FOOTER //
// ./src/containers/ProjectMap/common.js